import { useState } from 'react';
import useDeepCompareEffect from 'use-deep-compare-effect';
import { paymentMethodCodes } from '../../../constants/paymentMethods';
import { getMethod } from '../../../utils/paymentMethods';
import { createScript, removeScript } from '../utils/script';
import { initSession } from '../utils/session';

export const usePayPal = (paymentMethods) => {
  const [payPalSessionData, setPayPalSessionData] = useState('');

  useDeepCompareEffect(() => {
    const paypalPaymentMethod = getMethod(paymentMethods, paymentMethodCodes.PAYPAL);

    const initPayPal = async () => {
      const sessionData = await initSession();
      setPayPalSessionData(sessionData.token);
    };

    const braintreeClientScriptId = 'braintree-client';
    const braintreeCheckoutScriptId = 'braintree-checkout';
    if (paypalPaymentMethod) {
      createScript(
        braintreeClientScriptId,
        'https://js.braintreegateway.com/web/3.87.0/js/client.min.js',
      );
      createScript(
        braintreeCheckoutScriptId,
        'https://js.braintreegateway.com/web/3.87.0/js/paypal-checkout.min.js',
      );

      initPayPal();
    }

    return () => {
      removeScript(braintreeClientScriptId);
      removeScript(braintreeCheckoutScriptId);
    };
  }, [paymentMethods]);

  return { payPalSessionData };
};
